import { render } from "./PersonalityTypeCard.vue?vue&type=template&id=6186c216"
import script from "./PersonalityTypeCard.vue?vue&type=script&lang=js"
export * from "./PersonalityTypeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__